<template>
  <vs-row>
    <!-- 그래프 1 -->
    <vs-col class="w-full pb-4">
      <monthly-chart-card :title="graph1.title" :year="graph1.year"
                          :data1="graph1.data1" :data2="graph1.data2"
                          :sum1="graph1.sum1" :sum2="graph1.sum2"
                          :labels="['상반기', '하반기']"
                          @change="yearChangeForGraph1" />
    </vs-col>

    <div class="w-full grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 mb-4">
      <!-- 그래프 2-->
      <vs-col>
        <half-year-comparison-card :title="graph2.title" :year="graph2.year" :month="graph2.month" :unit="graph2.unit" :heads="graph2.heads" :list="graph2.list" :has0-month="true" :getCol="getColForGraph2" @change="dateChangeForGraph2">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph2.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph2(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </half-year-comparison-card>
      </vs-col>

      <!-- 그래프 3 -->
      <vs-col>
        <half-year-comparison-h-bar-card dateType="yyyy-mm" :title="graph3.title" :unit="graph3.unit" :year="graph3.year" :month="graph3.month" :list="graph3.list" :has0-month="true" @change="dateRangeChangeForGraph3">
          <template v-if="projectId" slot="tools">
            <vs-button v-for="(button, idx) in getButtons" :key="idx" class="py-3 px-0 lg:px-8" type="border"
                       :color="button.dataType === graph3.dataType ? 'primary' : 'secondary'"
                       @click="dataTypeChangeForGraph3(button.dataType, button.label)">{{ button.label }}</vs-button>
          </template>
        </half-year-comparison-h-bar-card>
      </vs-col>
    </div>
  </vs-row>
</template>

<script>
/* eslint-disable brace-style */
import MonthlyChartCard from "@/views/graph-detail/components/MonthlyChartCard";
import MonthlyComparisonCard from "@/views/graph-detail/components/MonthlyComparisonCard";
import DailyComparisonCard from "@/views/graph-detail/components/DailyComparisonCard";
import HalfYearComparisonCard from "@/views/graph-detail/components/HalfYearComparisonCard.vue";
import HalfYearComparisonHBarCard from "@/views/graph-detail/components/HalfYearComparisonHBarCard.vue";

export default {
  name: "GraphDetail42",
  components: {
    HalfYearComparisonHBarCard,
    HalfYearComparisonCard,
    DailyComparisonCard,
    MonthlyComparisonCard,
    MonthlyChartCard,
  },
  props: {
    comGroupList: Object,
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    graphId() {
      return Number(this.$route.params.graphId);
    },
    getButtons() {
      switch (this.getLevel) {
      case 1:
        return [
          {label: '부서(국)', dataType: 'company1'},
          {label: '부서(과)', dataType: 'company2'},
          { label: '구분', dataType: 'category' },
          { label: '공중이용시설', dataType: 'field' },
          { label: '예산항목', dataType: 'detail' },
        ];
      case 2:
        return [
          {label: '부서(국)', dataType: 'company0'},
          {label: '부서(과)', dataType: 'company1'},
          { label: '구분', dataType: 'category' },
          { label: '공중이용시설', dataType: 'field' },
          { label: '예산항목', dataType: 'detail' },
        ];
      case 3:
        return [
          {label: '부서(과)', dataType: 'company0'},
          { label: '구분', dataType: 'category' },
          { label: '공중이용시설', dataType: 'field' },
          { label: '예산항목', dataType: 'detail' },
        ];
      case 4:
        return [
          { label: '구분', dataType: 'category' },
          { label: '공중이용시설', dataType: 'field' },
          { label: '예산항목', dataType: 'detail' },
        ];
      }
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const project of projects) {
          if (`${project.id}` === `${this.projectId}` && project.company.length > 0) {
            const path = project.company[0].pivot.company_path;
            return path.split("/").length - 1; // Level
          }
        }
      }
    },
  },
  data() {
    return {
      boardIds: [479, 661],
      // 중대시민재해일 경우 :
      // 도서관 - library
      // 박물관 및 미술관 - museum
      // 의료기관 - medical
      // 어린이집 - daycare
      // 업무시설 - office
      // 실내공연장 - indoor-auditorium
      // 둘이상용도건축물 - mixed-use-building
      // 건축물 - building
      // 항만 - port
      // 교량 - bridge
      // 터널 - tunnel
      // 옹벽 - retaining-wall
      fieldCodes: ['library', 'museum', 'medical', 'daycare', 'office', 'indoor-auditorium', 'mixed-use-building', 'building', 'port', 'port-dock', 'bridge', 'tunnel', 'retaining-wall'],
      summaryKeys: {
        'detail' : ['안전보건예산_항목명', 'sum'],
        'field' : ['안전보건예산_사업장명', 'sum'],
        'address': ['안전보건예산_사업장주소', 'sum'],
        'field_cat1' : ['유해위험요인점검_사업장구분', 'sum'],
        'company' : ['안전보건예산_항목명', 'sum'],
        'project' : ['안전보건예산_항목명', 'sum'],
      },
      buttons: [
        { label: '부서', dataType: 'company' },
        { label: '행정동', dataType: 'address' },
        { label: '사업장', dataType: 'field' },
        { label: '예산항목', dataType: 'detail' },
      ],
      graph1: {
        title: "전체 공중이용시설 안전·보건 예산 현황",
        year: new Date().getFullYear(),
        data1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도
        data2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], // 선택한 년도의 이전 년도
      },
      graph2: {
        title: "월별 공중이용시설 안전·보건 예산 현황",
        year: new Date().getFullYear(),
        // 1~6월 : 1, 7~12월 : 2
        month: new Date().getMonth() < 6 ? 1 : 2,
        unit: "",
        heads: [{ name: "No." }, { name: "예산항목" }, { name: "예산(원)" }, { name: "전월대비 증감(원)" }],
        list: [],
        dataType: this.$route.params.proj_id ? "detail" : "project",
      },
      graph3: {
        title: "기간별 공중이용시설 안전·보건 예산 현황",
        unit: "",
        year: new Date().getFullYear(),
        // 1~6월 : 1, 7~12월 : 2
        month: new Date().getMonth() < 6 ? 1 : 2,
        list: [],
        dataType: this.$route.params.proj_id ? "detail" : "project",
      },
      cache: {},
      loading: false,
    };
  },
  created() {},
  async mounted() {
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");

    await this.loadDetailData();

    await this.loadGraph1();
    await this.loadGraph2();
    await this.loadGraph3();

    this.$nextTick(() => {
      this.dataTypeChangeForGraph2(this.graph2.dataType, this.getButtons[0].label);
      this.dataTypeChangeForGraph3(this.graph3.dataType, this.getButtons[0].label);
    });
  },
  methods: {
    async loadDetailData(currentYear, depth = -1) {
      if (!currentYear) {
        currentYear = new Date().getFullYear();
      }
      if (depth < 0) {
        depth = 1;
      }

      const cacheKey = `detail_${currentYear}_${depth}`;

      // 캐시에 저장되어 있으면, 캐시에서 불러온다
      if (this.cache[cacheKey]) {
        return JSON.parse(JSON.stringify(this.cache[cacheKey]));
      }
      // 캐시에 저장되어 있지 않으면, API에서 불러온다
      else {
        const params = {
          projectId: this.projectId,
          // fieldCode: 'facility-public',
          fieldCodes: this.fieldCodes,
          depth,
          currentYear,
          boardIds: this.boardIds,
        };

        this.$vs.loading();
        this.loading = true;
        try {
          const data = await this.$store.dispatch("summary/LOAD_DONUT_15_DETAIL", params);
          this.$vs.loading.close();
          this.loading = false;
          this.cache[cacheKey] = data;
          return data;
        } catch (e) {
          this.$vs.loading.close();
          this.loading = false;
          this.$vs.notify({title: "Error", text: "데이터를 불러오는데 실패했습니다.", color: "danger"});
        }
      }
    },
    // 그래프 1
    async loadGraph1() {
      const yyyy = this.graph1.year;
      const data = await this.loadDetailData(yyyy);
      const graph1Data = data.monthlyBudget;
      const currentYear = graph1Data[yyyy] ? graph1Data[yyyy] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      const prevYear = graph1Data[yyyy - 1] ? graph1Data[yyyy - 1] : [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

      // 첫번째 배열은 총 합이므로, 데이터에서 제외한다
      currentYear.shift();
      prevYear.shift();

      console.log(graph1Data);

      // this.graph1.data1의 개수가 12개일 경우, 0번째와 6번째만을 남긴다
      // 상반기, 하반기 데이터만 표시하기 위함
      if (currentYear.length === 12) {
        this.graph1.data1 = [currentYear[5], currentYear[11]];
      } else {
        this.graph1.data1 = currentYear;
      }

      if (prevYear.length === 12) {
        this.graph1.data2 = [prevYear[5], prevYear[11]];
      } else {
        this.graph1.data2 = prevYear;
      }

      const currentYearBudget = currentYear[currentYear.length - 1];
      const prevYearBudget = prevYear[prevYear.length - 1];
      this.graph1.sum1 = new Intl.NumberFormat().format(currentYearBudget);
      this.graph1.sum2 = new Intl.NumberFormat().format(prevYearBudget);
    },
    yearChangeForGraph1(year) {
      this.graph1.year = year;
      this.loadGraph1();
    },

    // 그래프 2
    async loadGraph2() {
      const yyyy = this.graph2.year;
      let depth = 1;
      if (this.graph2.dataType === 'company0') {
        depth = 0;
      } else if (this.graph2.dataType === 'company1') {
        depth = 1;
      } else if (this.graph2.dataType === 'company2') {
        depth = 2;
      }
      const data = await this.loadDetailData(yyyy, depth)

      let graph2Data = [];
      switch (this.graph2.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph2Data = JSON.parse(JSON.stringify(data.company));
        break;
      case "field":
        graph2Data = JSON.parse(JSON.stringify(data.field));
        break;
      case "detail":
        graph2Data = JSON.parse(JSON.stringify(data.budgetItem));
        break;
      case "address":
        graph2Data = JSON.parse(JSON.stringify(data.fieldAddress));
        break;
      default:
        return;
      }

      // 13개의 데이터(1~13번째는 월 별 데이터)를 2개의 데이터(상반기, 하반기)로 변경해야 한다
      for (const yearDataKey of Object.keys(graph2Data)) {
        const yearData = graph2Data[yearDataKey];
        const newYearData = [];
        newYearData.push(JSON.parse(JSON.stringify(yearData[12])));
        newYearData.push(JSON.parse(JSON.stringify(yearData[6])));
        newYearData.push(JSON.parse(JSON.stringify(yearData[12])));

        // newYearData[2] 항목 중에, 일치하는 label 값이 newYearData[1]이 있는 경우, budget 값을 뺀다
        for (const item of newYearData[2]) {
          const idx = newYearData[1].findIndex((row) => row.label === item.label);
          if (idx >= 0) {
            item.budget -= newYearData[1][idx].budget;
          }
        }

        // 만약 newYearData[2] 항목 중에 budget 값이 0인 경우, 제거한다
        newYearData[2] = newYearData[2].filter((item) => item.budget !== 0);

        // yearData를 newYearData로 교체한다
        graph2Data[yearDataKey] = newYearData;
      }


      const currentYear = yyyy;
      const currentMonth = this.graph2.month;
      let prevYear = currentMonth === 1 ? currentYear - 1 : currentYear;
      let prevMonth = currentMonth === 1 ? 2 : currentMonth - 1;
      // 전체일 경우, 년도별로 비교해야 한다
      if (currentMonth === 0) {
        prevYear = currentYear - 1;
        prevMonth = 0;
      }

      const currentData = graph2Data[currentYear][currentMonth];
      const prevData = graph2Data[prevYear][prevMonth];

      const list = [];
      let no = 1;

      for (const row of currentData) {
        const prevRow = prevData.find((item) => item.label === row.label);
        const gap = prevRow ? row.budget - prevRow.budget : row.budget;
        list.push({
          no,
          name: row.label,
          value: `${new Intl.NumberFormat().format(row.budget)  }`,
          valueRaw: row.budget,
          gap,
        });
        no += 1;
      }

      // 만약 list 아이템 중에 prevData에 없는 항목이 있다면, 추가한다 (budget : 0, gap : -item.budget)
      for (const item of prevData) {
        if (!list.find((row) => row.name === item.label)) {
          list.push({
            no,
            name: item.label,
            value: `${new Intl.NumberFormat().format(0)}`,
            valueRaw: 0,
            gap: -item.budget,
          });
          no += 1;
        }
      }

      // list를 value 기준으로 내림차순 정렬한다
      list.sort((a, b) => b.valueRaw - a.valueRaw);

      this.graph2.list = list;
    },
    getColForGraph2(index, value) {
      if (index === 0) return value.no;
      if (index === 1) return value.name;
      if (index === 2) return value.value;
      if (index === 3) {
        let updown = "default";
        if (value.gap > 0) updown = "up";
        else if (value.gap < 0) updown = "down";
        return { type: updown, value: `${new Intl.NumberFormat().format(value.gap)  }` };
      }
      return "";
    },
    dateChangeForGraph2(year, month) {
      this.graph2.year = year;
      this.graph2.month = month;

      this.dataTypeChangeForGraph2(this.graph2.dataType);
    },
    dataTypeChangeForGraph2(dataType, label = "") {
      if (label) {
        this.graph2.heads[1].name = label
      }

      if (this.graph2.month === 0) {
        this.graph2.heads[3].name = '전년대비 증감(원)'
      } else {
        this.graph2.heads[3].name = '전반기대비 증감(원)'
      }

      if (this.projectId) {
        this.graph2.dataType = dataType;
        this.loadGraph2();
      }
    },

    // 그래프 3
    async loadGraph3() {
      const yyyy = this.graph3.year;
      let depth = 1;
      if (this.graph3.dataType === 'company0') {
        depth = 0;
      } else if (this.graph3.dataType === 'company1') {
        depth = 1;
      } else if (this.graph3.dataType === 'company2') {
        depth = 2;
      }
      const data = await this.loadDetailData(yyyy, depth)
      let graph3Data = [];
      switch (this.graph3.dataType) {
      case "company0":
      case "company1":
      case "company2":
        graph3Data = JSON.parse(JSON.stringify(data.company));
        break;
      case "field":
        graph3Data = JSON.parse(JSON.stringify(data.field));
        break;
      case "detail":
        graph3Data = JSON.parse(JSON.stringify(data.budgetItem));
        break;
      case "address":
        graph3Data = JSON.parse(JSON.stringify(data.fieldAddress));
        break;
      default:
        return;
      }

      // 13개의 데이터(1~13번째는 월 별 데이터)를 2개의 데이터(상반기, 하반기)로 변경해야 한다
      for (const yearDataKey of Object.keys(graph3Data)) {
        const yearData = graph3Data[yearDataKey];
        const newYearData = [];
        newYearData.push(JSON.parse(JSON.stringify(yearData[12])));
        newYearData.push(JSON.parse(JSON.stringify(yearData[6])));
        newYearData.push(JSON.parse(JSON.stringify(yearData[12])));

        // newYearData[2] 항목 중에, 일치하는 label 값이 newYearData[1]이 있는 경우, budget 값을 뺀다
        for (const item of newYearData[2]) {
          const idx = newYearData[1].findIndex((row) => row.label === item.label);
          if (idx >= 0) {
            item.budget -= newYearData[1][idx].budget;
          }
        }

        // 만약 newYearData[2] 항목 중에 budget 값이 0인 경우, 제거한다
        newYearData[2] = newYearData[2].filter((item) => item.budget !== 0);

        // yearData를 newYearData로 교체한다
        graph3Data[yearDataKey] = newYearData;
      }

      const currentYear = yyyy;
      const currentMonth = this.graph3.month;
      const currentData = graph3Data[currentYear][currentMonth];

      const list = [];

      for (const row of currentData) {
        list.push({
          label: row.label,
          value: row.budget,
        });
      }

      // list를 value 값 기준으로 내림차순 정렬한다
      list.sort((a, b) => b.value - a.value);

      this.graph3.list = list;
    },

    dateRangeChangeForGraph3(year, month) {
      this.graph3.year = year;
      this.graph3.month = month;
      this.loadGraph3();
    },
    dataTypeChangeForGraph3(dataType, /*label*/) {
      if (this.projectId) {
        this.graph3.dataType = dataType;
        this.loadGraph3();
      }
    },
  },
};
</script>

<style scoped></style>
